"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformStyles = void 0;
var uppercaseCheck = /([A-Z])/;
var uppercasePattern = /([A-Z])/g;
var prefixAndLowerCase = function (char) { return "-" + char.toLowerCase(); };
var hyphenate = function (str) { return (uppercaseCheck.test(str) ? str.replace(uppercasePattern, prefixAndLowerCase) : str); };
/**
 * Транформирует объект стилей,
 * оставляя значения как есть (например, не добавляя "px" к числам),
 * а ключи переводя в kebab-case.
 * Подходит для подготовки типографической темы.
 */
exports.transformStyles = function (styles) {
    return Object.entries(styles)
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return hyphenate(key) + ": " + value;
    })
        .join(';');
};
//# sourceMappingURL=transformStyles.js.map